import Route from '@ember/routing/route'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import { service } from '@ember/service'
import type Store from '@ember-data/store'
import type Student from 'teacher-ui-client/models/student'

export default class RexReadAloudStudentRoute extends Route {
  queryParams = {
    sort: {
      replace: true,
    },
    pageNumber: {
      replace: true,
    },
    perPage: {
      replace: true,
    },
  }

  @service store!: Store

  model({ student_id: studentId }: { student_id: string }) {
    const { period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>
    const student = this.store.peekRecord<Student>('student', studentId)
    return { period, student }
  }
}
